import axios from '@fs/zion-axios'

const serviceBase = '/service/discovery/common'
const inCenterServiceBase = '/service/discovery/incenterexperience'

/**
 * Get all discovery centers
 * @returns {Promise<Array>} Array of center objects with id, code, name, latitude, longitude
 */
export const getDiscoveryCenterData = async () => {
  const response = await axios.get(`${inCenterServiceBase}/discovery-centers`)
  return response.data
}

/**
 * Get a single discovery center by its code (public endpoint)
 * @param {string} centerCode - Center code like "FHL", "LEH", "cody", etc.
 * @returns {Promise<Object>} Center object with id, code, name, latitude, longitude
 */
export const getDiscoveryCenterDataByCode = async (centerCode) => {
  const response = await axios.get(`${inCenterServiceBase}/discovery-centers/${encodeURIComponent(centerCode)}`)
  return response.data
}

/**
 * Create a new discovery center (admin/support only)
 * @param {Object} data - { code, name, latitude, longitude }
 * @returns {Promise<Object>} Axios response object
 */
export const createDiscoveryCenterCode = async (data) => {
  const response = await axios.post(`${inCenterServiceBase}/support/discovery-centers`, data)
  return response
}

/**
 * Update an existing discovery center (admin/support only)
 * @param {number} centerId - Database ID (not the code!)
 * @param {Object} data - { code, name, latitude, longitude }
 * @returns {Promise<Object>} Axios response object
 */
export const updateDiscoveryCenterCode = async (centerId, data) => {
  const response = await axios.put(`${inCenterServiceBase}/support/discovery-centers/${centerId}`, data)
  return response
}

/**
 * Delete a discovery center (admin/support only)
 * @param {string} centerCode - Center code like "FHL", "LEH", etc. (not the ID!)
 * @returns {Promise<Object>} Axios response object
 */
export const deleteDiscoveryCenterCode = async (centerCode) => {
  const response = await axios.delete(`${inCenterServiceBase}/support/discovery-centers/${centerCode}`)
  return response
}

/**
 * Get email history for keepsakes (support only)
 * @param {string} emailAddress - Email address to look up
 * @returns {Promise<Array>} Array of email history objects
 */
export const getEmailHistory = async (emailAddress) => {
  const response = await axios.get(`${serviceBase}/support/email/keepsakes/history`, {
    params: { emailAddress },
  })
  return response.data
}
